// extracted by mini-css-extract-plugin
export default {"layoutHeaderWrapper":"layoutHeader_layoutHeaderWrapper__g2WHt","layoutSection":"layoutHeader_layoutSection__6M1HX"};